import { Box, ButtonProps as MuiButtonProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';

const useStyles = makeStyles()(theme => ({
  addButton: {
    minWidth: theme.spacing(7.25),
    padding: 0,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focusVisible': {
      outlineOffset: -2,
    },
  },
  text: {
    paddingLeft: theme.spacing(0.5),
  },
  added: {
    display: 'flex',
    minWidth: theme.spacing(9.125),
    paddingLeft: theme.spacing(1),
    gap: theme.spacing(0.5),
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface AddButtonProps extends Omit<MuiButtonProps, 'variant'> {
  isAdded: boolean;
  onClick: () => void;
}

// todo: add functionality to forcefully display
const AddButton = (props: AddButtonProps) => {
  const { isAdded, ...rest } = props;
  const { classes, cx } = useStyles();
  const { className } = rest;

  if (isAdded)
    return (
      <Box className={classes.added}>
        <Icon type="check" color="disabled" />
        <Typography variant="pSm" bold uppercased color="secondary">
          {'Added'}
        </Typography>
      </Box>
    );

  return (
    <Button
      {...rest}
      variant="text"
      classes={{ root: cx(classes.addButton, className) }}
    >
      <Icon type="add" />
      <Typography
        variant="pSm"
        bold
        uppercased
        color="action"
        className={classes.text}
      >
        {'Add'}
      </Typography>
    </Button>
  );
};

export default AddButton;
